import React, { Component } from 'react';
import { connect } from "react-redux";
import Dialog from "material-ui/Dialog";
import classNames from 'classnames';

import {getPatientSkillAcqCollectedData,deletePatientSkillAcqCollectedData} from './actions/targetsAction';
import { CancelButton } from '../../../../../../../../components/buttons';
import SmallLoader from '../../../../../../../../img/small-loader.gif';
import { showFormatedDateandTime } from '../../../../../../../../actions/utilAction';

import { confirmAlert } from 'react-confirm-alert'; // Import
import Tooltip from '../../../../../../../../components/Tooltip';

class TodaysDTTDataModal extends Component {

    constructor(props) {
        super(props);
        this.state = {
            open: true,
            patientId: props.patientId ? parseInt(props.patientId) : null,
            deleteModal: false

        }
    }

    componentWillMount = () => {
        this.props.getPatientSkillAcqCollectedData(this.state.patientId, this.props.uuid, this.props.creadteDate, "DTT")
    }

    componentWillReceiveProps(nextProps) {
        // This is commented because of the two child modals
        // Please ask shubham first before uncommenting this

        // let self = this;
        // document.onkeydown = function (evt) {
        //     evt = evt || window.event;
        //     if (evt.keyCode === 27) {
        //         self.handleClose();
        //     }
        // };
    }

    handleClose = () => {
        if (this.state.open) {
            this.setState({ open: false });
            this.props.closeDialog();
        }
    };

    handleDeleteClick = (e, Obj) => {
        this.setState({
            deleteModal : true
        })
        
        confirmAlert({
            title: 'Delete Selected Trial',
            message: 'Are you sure you want to delete this trial?',
            buttons: [
              {
                label: 'Yes',
                onClick: () => {
                    this.props.deletePatientSkillAcqCollectedData(this.state.patientId, this.props.uuid, this.props.creadteDate,Obj.id, Obj.skillsAcquisitionTargetId, "DTT")
                    this.setState({
                        deleteModal: false
                    })
                }

              },
              {
                label: 'No',
                onClick: () => {
                    this.setState({
                        deleteModal: false
                    })
                }
              }
            ],
            closeOnClickOutside: false, //By Default it is true
            closeOnEscape: false,       //By Default it is true
          });
    }

    renderLoading = () => {
        return (
            <div>
                {this.props.loading ? (
                    <div className="full_loader top0">
                        <div className="small-loader">
                            <img src={SmallLoader} alt="" />
                        </div>
                    </div>
                ) : null}
            </div>
        );
    }

    renderData = (PatientSkillAcqCollectedDataList) => {
        PatientSkillAcqCollectedDataList = PatientSkillAcqCollectedDataList || [];
        if (!PatientSkillAcqCollectedDataList.length) {
            return (
                <tr>
                    <td colSpan="5">
                        <div className="text-center no-record">{this.props.loading ? 'Loading please wait...' : 'No record found.'}</div>
                    </td>
                </tr>
            );
        }
        return PatientSkillAcqCollectedDataList.map((Obj, index) => {
            return (
                <tr key={index}>
                    <td>
                        {Obj.programName && Obj.programName.length > 0 ?
                        <Tooltip Description={Obj.programName} />
                        : null}
                        {Obj.targetName}
                    </td>   
                    <td>
                        {Obj.domainName && Obj.domainName.length > 0 ?
                        <Tooltip Description={Obj.domainName} />
                        : null}                       
                    </td>                    
                    <td>{Obj.abbreviation}</td>
                    <td>{showFormatedDateandTime(Obj.sessionDate)}</td>
                    <td>
                    <button onClick={(e) => this.handleDeleteClick(e, Obj)} title="Delete" type="button" className="tbactionbtn redfont"><i className="fa fa-trash-o" aria-hidden="true"></i></button>
                    </td>
                </tr>
            )
        })
    }

    renderPatientSkillAcqCollectedDataList = () => {
        const tableClass = classNames({
            'table': true,
            'table-striped': this.props.condensed,
            'table-bordered': this.props.bordered,
            'table-hover': true,
            'table-condensed': this.props.condensed,
            'customtable': true,
        });
        const { patientSkillAcqCollectedDataList } = this.props;
        let PatientSkillAcqCollectedDataList = (patientSkillAcqCollectedDataList && patientSkillAcqCollectedDataList.data.PatientSkillsAcqCollectedData) || [];
        return (
            <div className="readmin-panel mt-10">
                <div className="panel-body">
                    <div className="row">
                        <div className="col-sm-12">
                            <div className="table-responsive mt-15">
                                <table className={tableClass}>
                                    <thead>
                                        <tr>
                                            <th width="50%">Target Name</th>                                            
                                            <th width="10%">Domain</th>
                                            <th width="10%">Answer</th>
                                            <th width="20%">Session Date</th>
                                            <th width="10%">Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.renderData(PatientSkillAcqCollectedDataList)}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    render() {
        const actions = [<CancelButton className="mr-15" onTouchTap={this.handleClose} />];
        return (
            <div>
                {!this.state.deleteModal && <Dialog
                    className="custom_modal"
                    title="Undo Past Data"
                    modal={false}
                    open={this.state.open}
                    actions={actions}
                    autoScrollBodyContent={true}
                >
                    {this.renderLoading()}
                    {this.renderPatientSkillAcqCollectedDataList()}
                </Dialog>}
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        loading: state.patientSkillAcqActiveTarget.loading,
        patientSkillAcqCollectedDataList: state.patientSkillAcqActiveTarget.patientSkillAcqCollectedDataList,
    }
}

export default connect(mapStateToProps, { getPatientSkillAcqCollectedData, deletePatientSkillAcqCollectedData })(TodaysDTTDataModal)




// WEBPACK FOOTER //
// ./src/modules/patients/components/collectData/componnets/SkillAquisition/components/targets/TodaysDTTDataModal.js